"use strict";
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var container = _7a468({ defaultClassName: "FolderComponent_container__vcj4k00", variantClassNames: { draggedOver: { true: "FolderComponent_container_draggedOver_true__vcj4k01" } }, defaultVariants: {}, compoundVariants: [] });
